import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type InterpreterScriptState = {
  data: string;
  isEnabled: boolean;
  isLoading: boolean;
  isLoaded: boolean;
  error: string | null;
};

export const emptyInterpreterScript: InterpreterScriptState = {
  data: "",
  isEnabled: false,
  isLoading: false,
  isLoaded: false,
  error: null,
};

type ScriptResult = { callerId: string; isEnabled: boolean; script: string };
const initialState: { byCaller: Record<string, InterpreterScriptState> } = { byCaller: {} };

const sliceInterpreterScript = createSlice({
  name: "sliceInterpreterScript",
  initialState,
  reducers: {
    FetchStart: (state, action: PayloadAction<string>) => {
      state.byCaller[action.payload] = { ...emptyInterpreterScript, isLoading: true };
    },
    FetchSuccess: (state, { payload }: PayloadAction<ScriptResult>) => {
      state.byCaller[payload.callerId] = {
        ...emptyInterpreterScript,
        data: payload.isEnabled ? payload.script : "",
        isEnabled: payload.isEnabled,
        isLoaded: true,
      };
    },
    FetchFailure: (state, { payload }: PayloadAction<{ callerId: string; error: string }>) => {
      state.byCaller[payload.callerId] = { ...emptyInterpreterScript, error: payload.error };
    },
    Clear: () => initialState,
  },
});

export const ReducerInterpreterScript = sliceInterpreterScript.reducer;
export const ActionInterpreterScript = sliceInterpreterScript.actions;
